import { useState } from 'react';
import { Col, Row } from 'antd';

import { ReactComponent as DeleteIcon } from '../../../../../../assets/icons/delete-icon.svg';
import IconButton from '../../../../../components/Buttons/IconButton';
import SvgConverter from '../../../../../components/Common/SvgConverter';
import FormCheckBox from '../../../../../components/Inputs/FormCheckBox';
import FormInput from '../../../../../components/Inputs/FormInput';
import SaveCancelButtons from '../../../../Quote/components/SaveCancelButtons';
import HalDeleteUserModal from './HalDeleteUserModal';

const HalCollboratorLogDetails = ({
  collaborator,
  isEdit,
  handleShowModal,
  providersDetails,
  name,
  selectedRouting,
  deleteCollaborator,
  isCreate,
  isHideButtons = false,
  isHideCheckbox = false,
  existedCollaborators = [],
  showType = true,
}) => {
  const isCollaboratorExists = existedCollaborators.includes(collaborator?.userId);

  const handleEdit = () => {
    handleShowModal('editModal', collaborator);
  };
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  return (
    <>
      <div
        className={`paper-container ${!isEdit ? 'guide-card-container' : ''} border-muted mb-15 ant-collapse-header`}
        data-testid="hal-collborator-log-details"
      >
        <div className="py-10" data-testid="hal-collborator-log-details">
          <Row gutter={10} className="flex-nowrap px-15" justify="start">
            {!isHideCheckbox && (
              <Col sm={1}>
                <FormCheckBox
                  disabled={isCollaboratorExists}
                  checkBoxClass="normal-checkbox"
                  className="form-radio-group-container"
                  name={[name, 'isChecked']}
                  checked={providersDetails?.isChecked || collaborator?.isChecked}
                />
              </Col>
            )}
            <Col sm={4} data-testid="hal-collborator-user-name">
              <p className="m-0 fw-400 f-12 color-label">User Name</p>
              <p className="mt-1 fw-500 f-13 color-dark">
                {collaborator?.userName || providersDetails?.label || collaborator?.name}
              </p>
            </Col>
            {showType && (
              <Col sm={3} data-testid="hal-collborator-type">
                <p className="m-0 fw-400 f-12 color-label">Type</p>
                <p className="mt-1 fw-500 f-13 color-dark">{collaborator?.group || providersDetails?.group || ''}</p>
              </Col>
            )}
            <Col sm={6}>
              {isEdit ? (
                <FormInput className="m-0 fw-400 f-12 color-label" label="Email" editMode name={[name, 'email']} />
              ) : (
                <>
                  <p className="m-0 fw-400 f-12 color-label">Email</p>
                  <p className="mt-1 fw-600 f-13 color-dark">{collaborator?.email || collaborator?.emails || ''}</p>
                </>
              )}
            </Col>
            <Col sm={4} data-testid="hal-collborator-role">
              <p className="m-0 fw-400 f-12 color-label">Role</p>
              <p className="mt-1 fw-500 f-13 color-dark">{collaborator?.role || providersDetails?.role || ''}</p>
            </Col>
            <Col sm={4} data-testid="hal-collborator-notifications">
              <p className="m-0 fw-400 f-12 color-label">Notification e-mails</p>
              <p className="mt-1 fw-500 f-13 color-dark">{collaborator?.notificationsEnabled ? 'On' : 'Off'}</p>
            </Col>
            {!isEdit && !isHideButtons && (
              <Col sm={4} className="d-flex align-items-center justify-content-center hidden-buttons">
                <SaveCancelButtons setEditMode={handleEdit} editMode={false} lightMode={false} hideDeleteButton />
                <IconButton className="ml-16" onClick={() => setIsDeleteModalOpen(true)}>
                  <SvgConverter Icon={DeleteIcon} color="iconDanger" width={16} height={16} />
                </IconButton>
              </Col>
            )}
            {isCollaboratorExists && (
              <Col sm={2} className="d-flex align-items-center">
                Added
              </Col>
            )}
          </Row>
        </div>
      </div>
      <HalDeleteUserModal
        handleCloseDeleteModal={() => setIsDeleteModalOpen(false)}
        name={collaborator?.name || ''}
        isModalOpen={isDeleteModalOpen}
        collaborator={collaborator}
        isForCollaborator
        selectedRouting={selectedRouting}
        customSubmit={isCreate && deleteCollaborator}
      />
    </>
  );
};

export default HalCollboratorLogDetails;
